import { RecipientHeadingEnum } from "./shared/Enums/recipient-table-enum";
export let DEFAULT_RADIO_BUTTON_SELECTION = "To";
export const RECIPIENT_ALREADY_ADDED_MESSAGE = "Recipient has already been added on the table";
export const DEFAULT_RECIPIENT_LABEL = "Add recipient";
export const NO_GROUPS_DETECTED_ERR_MSG = "No groups detected in the step's metadata, please contact your administrator.";
export const RecipientsHeadingLookup = new Map([
    [RecipientHeadingEnum.name, "name"],
    [RecipientHeadingEnum.surname, "surname"],
    [RecipientHeadingEnum.designation, "designation"],
    [RecipientHeadingEnum.organisation, "organisation"],
    [RecipientHeadingEnum.telephone, "telephone"],
    [RecipientHeadingEnum.email, "email"],
    [RecipientHeadingEnum.defaultCommunicationMethod, "defaultCommunicationMethod"]
]);
